import { AddressDTO } from '@services/DTO/AddressDTO'
import { PaymentsAccountDTO } from '@services/DTO/PaymentsAccountDTO'
import { VenueDTO } from '@services/DTO/VenueDTO'
import { PaymentProviderCapability } from '@app/domain/PaymentsAccount'

export class BusinessDTO {

    constructor(
        public id: string,
        public displayName: string,
        public phoneNumber: string,
        public address: AddressDTO,
        public paymentsAccount: PaymentsAccountDTO | null,
        public venues: VenueDTO[],
        public paymentsAccounts: PaymentsAccountDTO[] = [],
        public paymentsAccountAssignments?: Partial<Record<PaymentProviderCapability, string>>
    ) { }
}
